export function businessSeoTitle(value) {
  const clean = String(value || '').replace(/\s*(?:[-–—|]\s*)?Lovable\b/gi, '').trim();
  return /O[-‐‑]FIX/i.test(clean) ? clean : `${clean || 'O-FIX'} | O-FIX`;
}